import React from 'react'

import styled from 'styled-components'
import { useTranslation } from 'react-i18next'

import { GreenTextButtonProps } from 'src/Components/Buttons/GreenTextButton'
import { HUNDREDTHS } from 'src/Constants/numeric'
import { MAX_MOBILE_WIDTH } from 'src/Styled/variables'
import { GreyTextButton } from 'src/Components/Buttons/GreyTextButton'

const StyledGreyTextButton = styled(GreyTextButton)`
  @media (max-width: 767px) {
    flex-grow: 1;
  }
`

const BalanceDescription = styled.span`
  @media (max-width: ${MAX_MOBILE_WIDTH}) {
    display: none;
  }
`

export type BalanceButtonProps = Pick<
  GreenTextButtonProps,
  'loading' | 'onClick' | 'className' | 'disabled'
> & { balance: number }

export const BalanceButton: React.FC<BalanceButtonProps> = ({
  balance = 0,
  loading,
  onClick,
  className,
  disabled,
}) => {
  const { t } = useTranslation()

  const formattedBalance = balance.toFixed(HUNDREDTHS)

  return (
    <StyledGreyTextButton
      loading={loading}
      disabled={disabled}
      onClick={onClick}
      className={className}
    >
      <BalanceDescription>{t('header.balanceButtonTitle')}</BalanceDescription>
      <span>{`$${formattedBalance}`}</span>
    </StyledGreyTextButton>
  )
}
